var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRankingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2364.5,-635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rankings-Icon",
    serifId: "Rankings Icon"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.670081,0,0,0.961272,787.715,25.5215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2363.57,642.095C2363.57,641.091 2362.4,640.275 2360.96,640.275L2355.74,640.275C2354.3,640.275 2353.13,641.091 2353.13,642.095L2353.13,657.179C2353.13,658.184 2354.3,659 2355.74,659L2360.96,659C2362.4,659 2363.57,658.184 2363.57,657.179L2363.57,642.095Z",
    style: {
      fill: "rgb(51,57,68)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.670081,0,0,1.2817,796.715,-185.638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2363.57,641.64C2363.57,640.887 2362.4,640.275 2360.96,640.275L2355.74,640.275C2354.3,640.275 2353.13,640.887 2353.13,641.64L2353.13,657.635C2353.13,658.388 2354.3,659 2355.74,659L2360.96,659C2362.4,659 2363.57,658.388 2363.57,657.635L2363.57,641.64Z",
    style: {
      fill: "rgb(51,57,68)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.670081,0,0,0.640848,805.715,236.681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2363.57,643.006C2363.57,641.498 2362.4,640.275 2360.96,640.275L2355.74,640.275C2354.3,640.275 2353.13,641.498 2353.13,643.006L2353.13,656.269C2353.13,657.776 2354.3,659 2355.74,659L2360.96,659C2362.4,659 2363.57,657.776 2363.57,656.269L2363.57,643.006Z",
    style: {
      fill: "rgb(51,57,68)"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankingsIcon);
export default __webpack_public_path__ + "static/media/rankings_icon.9a443d6730a93b020328f129d817b7f3.svg";
export { ForwardRef as ReactComponent };